import useFetch from '../../../hooks/useFetch';
import Api from '../../../api';

const useGettingDevices = () => {
  const { response: devices, onFetch: onFetchDevices } = useFetch(
    'devices',
    Api.DEVICES
  );

  return {
    devices,
    onFetchDevices,
  };
};

export default useGettingDevices;
